export default function About() {
    return (
        <div id="about">
            <div id="about-wrapper">
                <div id="about-image-container">
                    <img id="about-image" src="https://i.pinimg.com/originals/90/dd/d5/90ddd56d397cde75bb5c2dac304b2657.jpg" alt="julian portrait" />
                </div>
                <div id="about-bio">
                    <p>
                        Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
                    </p>
                </div>
            </div>
        </div>
    )
}